import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-form-etape-validation',
  templateUrl: './form-etape-validation.component.html',
  styleUrls: ['./form-etape-validation.component.scss']
})
export class FormEtapeValidationComponent implements OnInit {
  indiceTab: number = 0;
  decisionForm: FormGroup;
  items = [
    { id: 1, name: 'Élément A', status: 'En attente' },
    { id: 2, name: 'Élément B', status: 'En attente' },
    { id: 3, name: 'Élément C', status: 'En attente' }
  ];

  constructor(private fb: FormBuilder) {
    this.decisionForm = this.fb.group({
      decision: ['', Validators.required],
      reason: ['']
    });
  }

  isInvalid(controlName: string): boolean {
    const control = this.decisionForm.get(controlName);
    return control?.invalid && control?.touched;
  }

  onSubmit() {
    if (this.decisionForm.valid) {
      console.log('Formulaire soumis :', this.decisionForm.value);
      alert('Décision soumise avec succès !');
    } else {
      this.decisionForm.markAllAsTouched();
    }
  }
  selectedChangeValue(event : any)
  {
    console.log("le event selectedChangeValue",event);
    
    if(!event) this.indiceTab = 0;

    this.indiceTab = event;
  } 

  ngOnInit(): void {
  }

}
